import { useState, useEffect } from "react";

const Letter = ({ char, letters }) => {
  const [show, setShow] = useState("_");

  useEffect(() => {
    if (char === " ") setShow(" ");
    else if (letters.includes(char)) {
      setShow(char);
    } else setShow("_");
  }, [letters, char]);

  return <span className="char">{show}</span>;
};

export default Letter;
